import { TDrawEntry } from '@daymade/api-contracts';
import { GameType } from '@daymade/common-lib/dbEnums';
import EntryLine from 'components/EntryLine';
import RoundedButton from 'components/RoundedButton';
import { getCta } from 'utils/common';
import FreemiumSoClosePopup from '../FreemiumSoClosePopup/FreemiumSoClosePopup';
import { ENTRY_LINE_HEIGHT, PRIZE_MESSAGE_HEIGHT } from '../RevealAnimation';

interface UserEntriesSectionProps {
  entries: TDrawEntry[];
  revealInProgress: any;
  prizeWins: any;
  result: any;
  revealStage: any;
  revealStagePart: any;
  revealStarted: boolean;
  showFreemiumPopup: any;
  largestHypotheticalPrizeWin: any;
  setShowFreemiumPopup: any;
}

export const UserEntriesSection = ({
  entries,
  revealInProgress,
  prizeWins,
  result,
  revealStage,
  revealStagePart,
  revealStarted,
  showFreemiumPopup,
  largestHypotheticalPrizeWin,
  setShowFreemiumPopup,
}: UserEntriesSectionProps) => {
  if (!entries || entries.length === 0) {
    return (
      <div className="noEntriesSection">
        <p>
          You didn't have any entries for this draw 😢 Get your entries in for
          next week's draw to be in with a chance to win epic prizes!
        </p>

        <RoundedButton
          href={getCta()?.url}
          className="enterNowButton"
        >
          Enter now
        </RoundedButton>

        <style jsx>
          {`
            .noEntriesSection {
              text-align: center;
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 0 0 3em;
            }

            .noEntriesSection p {
              max-width: 280px;
              margin-bottom: 1.5em;
              text-align: center;
              font-weight: 600;
            }

            .noEntriesSection :global(.description) {
              color: #181919;
            }

            .noEntriesSection :global(.enterNowButton) {
              margin-top: 1em;
            }

            @media (min-width: 900px) {
              .noEntriesSection {
                padding: 0;
                width: 100%;
              }
            }
          `}
        </style>
      </div>
    );
  }

  return (
    <div className="userEntriesSection fullWidth flexCentered">
      <div
        className="linesContainer"
        style={{
          height:
            (revealInProgress ? 0 : prizeWins.length * PRIZE_MESSAGE_HEIGHT) +
            entries.length * ENTRY_LINE_HEIGHT,
        }}
      >
        {entries.map(
          (entry, index) =>
            entry.numbers.type === GameType.LOTTERY && (
              <div
                key={index}
                className="trophyLineContainer"
                id={`entryLine_${entry.id}`}
                style={{ top: ENTRY_LINE_HEIGHT * index }}
              >
                <EntryLine
                  lineIndex={index}
                  main={entry.numbers.main}
                  bonus={entry.numbers.bonus}
                  userEntry={true}
                  resultMain={result.main}
                  resultBonus={result.bonus}
                  revealStage={revealStage}
                  highlightStage={
                    revealStagePart === 'a'
                      ? /* This previously took 1 away from revealStge when revealStagePart was equal to 'a'. However,
                        this caused the bonus ball to never get highlighed.*/
                      revealStage 
                      : revealStage
                  }
                  className="line"
                  usingBonusBall={entry.numbers.bonus.length}
                  prizeCode={entry.prizeTierCode ?? undefined}
                  showPrizeWinMessage={
                    revealStarted &&
                    !revealInProgress &&
                    !!entry?.prizeTierCode &&
                    !entry.isHypotheticalPrize
                  }
                />
              </div>
            )
        )}

        {showFreemiumPopup && (
          <FreemiumSoClosePopup
            prize={largestHypotheticalPrizeWin}
            onClose={() => setShowFreemiumPopup(false)}
          />
        )}
      </div>
    </div>
  );
}
